import React from 'react'
import ComingSoon from '../../../components/ComingSoon/ComingSoon'

const RequestMoney = () => {
  return (
    <div><ComingSoon /></div>
  )
}

export default RequestMoney